/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401,
  PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500,
} from "../../types/pecegePayBilletController/PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1PecegepayBilletCancelCoursefinpersonpaymentid } from "../../clients/pecegePayBilletController/patchApiV1PecegepayBilletCancelCoursefinpersonpaymentid.ts";

export const patchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationKey =
  () =>
    [
      { url: "/api/v1/pecegepay/billet/cancel/:courseFinPersonPaymentId" },
    ] as const;

export type PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationKey =
  ReturnType<
    typeof patchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationKey
  >;

export function patchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    patchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationKey();
  return mutationOptions<
    PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401
      | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500
    >,
    {
      courseFinPersonPaymentId: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
      params?: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ courseFinPersonPaymentId, params }) => {
      return patchApiV1PecegepayBilletCancelCoursefinpersonpaymentid(
        courseFinPersonPaymentId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Registra o cancelamento de um boleto pelo ID da parcela.
 * @summary Cancelar boleto por parcela
 * {@link /api/v1/pecegepay/billet/cancel/:courseFinPersonPaymentId}
 */
export function usePatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401
        | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500
      >,
      {
        courseFinPersonPaymentId: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
        params?: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationKey();

  const baseOptions =
    patchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401
        | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500
      >,
      {
        courseFinPersonPaymentId: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
        params?: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams;
      },
      TContext
    >;

  return useMutation<
    PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401
      | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500
    >,
    {
      courseFinPersonPaymentId: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
      params?: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid401
      | PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentid500
    >,
    {
      courseFinPersonPaymentId: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
      params?: PatchApiV1PecegepayBilletCancelCoursefinpersonpaymentidQueryParams;
    },
    TContext
  >;
}
